import { ApolloClient } from "@apollo/client";
import {
  ICreateCreditMemoBatchRepository,
  ICreateCreditMemoBatchRepositoryParams,
  ICreateCreditMemoBatchRepositoryResponse,
} from "@/core/repositories/accounting";
import CREATE_CREDIT_MEMO_BATCH from "@/core/graphql/accounting/createCreditMemoBatch";

export class CreditMemoBatchRepository implements ICreateCreditMemoBatchRepository {
  constructor(private readonly client: ApolloClient) {}

  public async createCreditMemoBatch(
    params: ICreateCreditMemoBatchRepositoryParams
  ): Promise<ICreateCreditMemoBatchRepositoryResponse> {
    const { data } = await this.client.mutate<ICreateCreditMemoBatchRepositoryResponse>({
      mutation: CREATE_CREDIT_MEMO_BATCH,
      variables: {
        params: {
          accountingLinkedDeductions: params.accountingLinkedDeductions,
        },
      },
    });

    if (!data) {
      throw new Error("Failed to create credit memo batch");
    }

    return data;
  }
}
